export default __webpack_public_path__ + "static/media/vegan.e9cc887b.jpg";